import React from "react";
import { Link } from "react-router-dom";
import { Info, Satellite, Link2, PlugZap } from "lucide-react";
import { useAuth } from "../../lib/auth";

export function SampleBadge({ testId }: { testId?: string }) {
  return <span data-testid={testId} className="inline-flex items-center gap-1 rounded-full bg-slate-200/80 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-slate-600 ring-1 ring-slate-300">Sample data</span>;
}

export function sampleWrap(active: boolean): string {
  return active ? "grayscale opacity-70 saturate-50 pointer-events-none select-none" : "";
}

export function TelematicsInstructions({ connected, linked, compact, testId = "sample-data-notice" }: { connected: boolean; linked?: boolean; compact?: boolean; testId?: string }) {
  const { user } = useAuth();
  const isBO = user?.user_type === "super_admin";
  const base = isBO ? "/bo" : "/app";
  const steps = [
    { done: connected, icon: PlugZap, text: isBO ? "Client admin connects their Geotab database under Settings → Telematics Connection" : "Connect your Geotab database under Settings → Telematics Connection", to: isBO ? undefined : "/app/settings/telematics", cta: "Connect Geotab" },
    { done: connected && linked, icon: Link2, text: "Link each vehicle to its Geotab device (auto-matched by plate number, or pick manually in vehicle details → Telematics)", to: `${base}/telematics/devices`, cta: "Link devices" },
    { done: false, icon: Satellite, text: "Live positions, trips, odometer and fuel then replace the sample values automatically", to: undefined, cta: "" },
  ];
  return (
    <div className={`rounded-lg border border-dashed border-slate-300 bg-slate-50/90 ${compact ? "p-3" : "p-4"}`} data-testid={testId}>
      <p className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-slate-600"><Info className="h-3.5 w-3.5" />Sample data shown — how to load real telematics</p>
      <ol className={`mt-2 space-y-1.5 ${compact ? "text-[11px]" : "text-xs"} text-slate-600`}>
        {steps.map((s, i) => (
          <li key={i} className="flex items-start gap-2">
            <span className={`mt-px flex h-4 w-4 shrink-0 items-center justify-center rounded-full text-[10px] font-bold ${s.done ? "bg-emerald-100 text-emerald-700" : "bg-slate-200 text-slate-600"}`}>{s.done ? "✓" : i + 1}</span>
            <span className={s.done ? "line-through opacity-60" : ""}>{s.text}{s.to && !s.done && <> · <Link to={s.to} className="font-semibold text-[color:var(--brand)] hover:underline" data-testid={`${testId}-cta-${i}`}>{s.cta} →</Link></>}</span>
          </li>
        ))}
      </ol>
    </div>
  );
}
